var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHallStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_376_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.923 15.3911L14.8605 17.8911C15.3683 18.2114 15.9933 17.7349 15.8449 17.1489L14.7042 12.6646C14.6734 12.5403 14.6783 12.4098 14.7184 12.2882C14.7585 12.1665 14.8321 12.0587 14.9308 11.9771L18.4621 9.03176C18.923 8.64895 18.6886 7.87551 18.0871 7.83644L13.4777 7.53957C13.3519 7.53225 13.231 7.48846 13.1297 7.41354C13.0284 7.33862 12.9512 7.23582 12.9074 7.1177L11.1886 2.78957C11.1431 2.66449 11.0602 2.55645 10.9512 2.4801C10.8422 2.40375 10.7123 2.36279 10.5792 2.36279C10.4461 2.36279 10.3163 2.40375 10.2073 2.4801C10.0982 2.55645 10.0154 2.66449 9.96987 2.78957L8.25112 7.1177C8.20731 7.23582 8.13005 7.33862 8.02877 7.41354C7.92749 7.48846 7.80657 7.53225 7.68081 7.53957L3.07143 7.83644C2.46987 7.87551 2.23549 8.64895 2.69643 9.03176L6.22768 11.9771C6.32638 12.0587 6.40001 12.1665 6.4401 12.2882C6.48018 12.4098 6.48509 12.5403 6.45424 12.6646L5.39956 16.8208C5.21987 17.5239 5.96987 18.0943 6.57143 17.7114L10.2355 15.3911C10.3382 15.3258 10.4575 15.2911 10.5792 15.2911C10.701 15.2911 10.8202 15.3258 10.923 15.3911V15.3911Z",
    stroke: "#4D2608",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_376_2879",
    x: 1.45664,
    y: 1.36279,
    width: 18.2452,
    height: 21.6421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_376_2879"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHallStarIcon);
export default __webpack_public_path__ + "static/media/hall_star_icon.e96fc4199b7e4fb05b6596e070f9685d.svg";
export { ForwardRef as ReactComponent };